// @ts-nocheck

export const localeCodes =  [
  "uk",
  "ru"
]
export const localeLoaders = {
  uk: [
    {
      key: "locale_uk_46json_64c4b714",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_f9c37154",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "uk",
    name: "Українська",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ru",
    name: "Русский",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

